import { Box, Button, styled } from "@mui/material";
import { darkColors } from "../../../theme/colors";
import { fontSizes } from "../../../theme/font-sizes";

const TabButton = styled(Button)(({ isMediumScreen, active }) => ({
  color: active ? "white" : darkColors.wagerGray,
  fontSize: isMediumScreen ? fontSizes.heading3 : fontSizes.superHeading6,
  fontWeight: 700,
  borderRadius: 99,
  padding: "3px 34px",
  background: active ? "#2D2C2C" : "none",
  textTransform: "none",
  border: active ? `1px solid ${darkColors.buttonTop}` : "none",
}));

export default function TabButtons({
  activeTab,
  setActiveTab,
  isMediumScreen,
}) {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        gap: 1,
        mt: isMediumScreen ? 1 : 2,
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          borderRadius: 99,
          py: 1,
          px: 1,
          border: `1px solid ${darkColors.borderGray}`,
        }}
      >
        <TabButton
          isMediumScreen={isMediumScreen}
          active={activeTab === "topup"}
          onClick={() => setActiveTab("topup")}
        >
          Topup
        </TabButton>
        <TabButton
          isMediumScreen={isMediumScreen}
          active={activeTab === "withdraw"}
          onClick={() => setActiveTab("withdraw")}
        >
          Withdraw
        </TabButton>
      </Box>
    </Box>
  );
}
